<div *ngIf="!campaign">Loading...</div>

<div class="campaign-page" *ngIf="campaign">

  <!-- Header -->
  <div class="campaign-header">
    <div class="creator-circle" [class.has-image]="creatorImageUrl" [title]="campaign.creatorName || ''">
      <img *ngIf="creatorImageUrl as url; else creatorInitial" [src]="url" alt="creator profile" referrerpolicy="no-referrer" (error)="onHeaderImageError(url)">
      <ng-template #creatorInitial>{{ campaign.creatorName ? campaign.creatorName.charAt(0).toUpperCase() : '?' }}</ng-template>
    </div>

    <div class="header-details">
      <div class="header-name">{{ campaign.name }}</div>
      <div class="header-field-row">
        <span class="handle-label">Creator:</span>
        <span class="header-sub-value">{{ campaign.creatorName }}<ng-container *ngIf="campaign.tiktokHandle"> ({{ campaign.tiktokHandle }})</ng-container></span>
      </div>
      <div class="header-field-row header-rate-row">
        <span class="header-pair">
          <span class="handle-label">Rate:</span>
          <span class="header-rate-value">{{ campaign.rate | currency:'USD':'symbol':'1.0-0' }}</span>
        </span>
        <span class="header-pair">
          <span class="handle-label header-sep">Commission:</span>
          <span class="header-rate-value">{{ campaign.commission }}%</span>
        </span>
        <span class="header-pair">
          <span class="handle-label header-sep">Terms:</span>
          <span class="header-rate-value">{{ campaign.paymentTerms }}</span>
        </span>
      </div>
      <div class="header-field-row">
        <span class="handle-label">Created:</span>
        <span class="header-value">{{ campaign.createdDate }}</span>
        <span class="handle-label header-sep">ID:</span>
        <span class="header-value">{{ campaign.id.substring(0, 8) }}</span>
      </div>
      <div class="header-field-row">
        <span class="handle-label">FEA:</span>
        <ng-container *ngIf="campaign.fea; else feaUpload">
          <a class="fea-link" [href]="'https://drive.google.com/file/d/' + campaign.fea + '/view'" target="_blank" rel="noopener">View agreement</a>
          <button type="button" class="fea-delete" [disabled]="isDeletingFea" (click)="deleteFea()">
            {{ isDeletingFea ? 'Deleting...' : 'Delete' }}
          </button>
          <span class="fea-error" *ngIf="feaError">{{ feaError }}</span>
        </ng-container>
        <ng-template #feaUpload>
          <input #feaInput type="file" accept=".pdf,.docx" style="display: none;" (change)="onFeaSelected($event)">
          <button type="button" class="fea-upload-btn" [disabled]="isUploadingFea" (click)="feaInput.click()">
            {{ isUploadingFea ? 'Uploading...' : 'Upload FEA' }}
          </button>
          <span class="fea-error" *ngIf="feaError">{{ feaError }}</span>
        </ng-template>
      </div>
    </div>

    <div class="brand-circle" [class.has-image]="brandImageUrl" [title]="getBrandName(campaign.brandId)">
      <img *ngIf="brandImageUrl as url; else brandInitial" [src]="url" alt="brand logo" (error)="onHeaderImageError(url)">
      <ng-template #brandInitial>{{ getBrandName(campaign.brandId) ? getBrandName(campaign.brandId).charAt(0).toUpperCase() : 'B' }}</ng-template>
    </div>
  </div>

  <hr class="section-divider">

  <!-- Tab Menu -->
  <div class="tab-menu">
    <div class="tab-item" [class.active]="activeTab === 'properties'" (click)="setTab('properties')">Properties</div>
    <div class="tab-item" [class.active]="activeTab === 'deliverables'" (click)="setTab('deliverables')">Deliverables</div>
    <div class="tab-item" [class.active]="activeTab === 'tasks'" (click)="setTab('tasks')">
      Tasks<span *ngIf="hasOverdueTasks" class="overdue-badge">!</span>
    </div>
    <div class="tab-item" [class.active]="activeTab === 'invoices'" (click)="setTab('invoices')">Invoices</div>
    <div class="tab-item" [class.active]="activeTab === 'exclusivities'" (click)="setTab('exclusivities')">Exclusivities</div>
    <div class="tab-item" [class.active]="activeTab === 'files'" (click)="setTab('files')">Files</div>
    <div class="tab-item" [class.active]="activeTab === 'liveVideos'" (click)="setTab('liveVideos')">Live Videos</div>
    <div class="tab-item" [class.active]="activeTab === 'changes'" (click)="setTab('changes')">Changes</div>
  </div>

  <!-- Tab Content -->
  <div class="tab-content">

    <!-- Properties Tab -->
    <div *ngIf="activeTab === 'properties'" class="campaign-items-container">
      <div class="camp-label">Campaign Id</div>
      <div class="camp-data">{{campaign.id}}<img class="copy-icon" (click)="copyCampaignId()" alt="copy icon" src="copy_icon.svg"></div>

      <div class="camp-label">Complete</div>
      <div class="camp-data"><input type="checkbox" [(ngModel)]="campaign.complete" (ngModelChange)="onFieldChange('complete', campaign.complete)"></div>

      <div class="camp-label">Campaign Name</div>
      <div class="camp-data"><input class="dark-input wide" type="text" [(ngModel)]="campaign.name" (ngModelChange)="onFieldChange('name', campaign.name)"></div>

      <div class="camp-label">Brand</div>
      <div class="camp-data">
        <select class="dark-input wide" [(ngModel)]="campaign.brandId" (change)="onFieldChange('brandId', $any($event.target).value)">
          <option value="">Not Set</option>
          <option *ngFor="let b of brands" [value]="b.id">{{b.name}}</option>
        </select>
      </div>

      <div class="camp-label">Account</div>
      <div class="camp-data">
        <select class="dark-input wide" [(ngModel)]="campaign.accountId" (change)="onFieldChange('accountId', $any($event.target).value)">
          <option value="">Not Set</option>
          <option *ngFor="let a of accounts" [value]="a.id">{{a.name}}</option>
        </select>
      </div>

      <div class="camp-label">Rate</div>
      <div class="camp-data"><input class="dark-input wide" type="number" [(ngModel)]="campaign.rate" (ngModelChange)="onFieldChange('rate', campaign.rate)"></div>

      <div class="camp-label">Source</div>
      <div class="camp-data">
        <select class="dark-input wide" [(ngModel)]="campaign.source" (change)="onFieldChange('source', $any($event.target).value)">
          <option value="Inbound">Inbound</option>
          <option value="Outbound">Outbound</option>
          <option *ngFor="let u of castingUsers" [value]="u.id">{{u.firstName}} {{u.lastName}}</option>
        </select>
      </div>

      <div class="camp-label">Description</div>
      <div class="camp-data">
        <textarea class="campaign-description" [(ngModel)]="campaign.description" (ngModelChange)="onFieldChange('description', campaign.description)"></textarea>
      </div>

      <div class="camp-label">Payment Schedule</div>
      <div class="camp-data">
        <textarea class="campaign-description" [(ngModel)]="campaign.paymentSchedule" (ngModelChange)="onFieldChange('paymentSchedule', campaign.paymentSchedule)"></textarea>
      </div>

      <div class="camp-label">Creative Overview</div>
      <div class="camp-data">
        <textarea class="campaign-description" [(ngModel)]="campaign.creativeOverview" (ngModelChange)="onFieldChange('creativeOverview', campaign.creativeOverview)"></textarea>
      </div>

      <div class="camp-label">Usage</div>
      <div class="camp-data">
        <textarea class="campaign-description" [(ngModel)]="campaign.usage" (ngModelChange)="onFieldChange('usage', campaign.usage)"></textarea>
      </div>

      <div class="camp-label">Agent Name</div>
      <div class="camp-data">
        <select class="dark-input wide" [(ngModel)]="campaign.agentId" (change)="onFieldChange('agentId', $any($event.target).value)">
          <option value="">Not Set</option>
          <option *ngFor="let u of agentUsers" [value]="u.id">{{u.firstName}} {{u.lastName}}</option>
        </select>
      </div>

      <div class="camp-label">Coordinator Name</div>
      <div class="camp-data">
        <select class="dark-input wide" [(ngModel)]="campaign.coordinatorId" (change)="onFieldChange('coordinatorId', $any($event.target).value)">
          <option value="">Not Set</option>
          <option *ngFor="let u of agentUsers" [value]="u.id">{{u.firstName}} {{u.lastName}}</option>
        </select>
      </div>

      <div class="camp-label">Payment Terms</div>
      <div class="camp-data"><input class="dark-input wide" type="text" [(ngModel)]="campaign.paymentTerms" (ngModelChange)="onFieldChange('paymentTerms', campaign.paymentTerms)"></div>

      <div class="camp-label">Commission</div>
      <div class="camp-data"><input class="dark-input wide" type="number" [(ngModel)]="campaign.commission" (ngModelChange)="onFieldChange('commission', campaign.commission)"></div>

      <div class="camp-label">Front Conversation Id</div>
      <div class="camp-data"><input class="dark-input wide" type="text" [(ngModel)]="campaign.frontConversationId" (ngModelChange)="onFieldChange('frontConversationId', campaign.frontConversationId)"></div>

      <div class="camp-label">Deleted</div>
      <div class="camp-data"><input type="checkbox" [(ngModel)]="campaign.deleted" (ngModelChange)="onFieldChange('deleted', campaign.deleted)"></div>

      <div class="camp-label">Reactivated</div>
      <div class="camp-data"><a href="#" (click)="campaign.reactivated = !campaign.reactivated; onFieldChange('reactivated', campaign.reactivated); $event.preventDefault()">{{campaign.reactivated ? 'Yes' : 'No'}}</a></div>
    </div>

    <!-- Deliverables Tab -->
    <div *ngIf="activeTab === 'deliverables'" class="tab-full-width">
      <div class="deliverable-table-wrapper">
        <div class="deliverable-add-row">
          <img class="add-icon-lg" src="add_icon.svg" (click)="addDeliverable()">
        </div>
        <div *ngIf="isLoadingDeliverables" class="no-items-msg">Loading deliverables...</div>
        <div class="deliverable-table">
          <div class="flex-cell dtable-header">Order</div>
          <div class="flex-cell dtable-header">Description</div>
          <div class="flex-cell dtable-header">Delete</div>
          <ng-container *ngFor="let d of campaign.deliverables; index as i">
            <div class="flex-cell dtable-row deliverable-order-cell">
              <span *ngIf="i > 0" class="order-arrow" (click)="moveDeliverable(i, -1)" title="Move up">&#9650;</span>
              <span *ngIf="i < campaign.deliverables.length - 1" class="order-arrow" (click)="moveDeliverable(i, 1)" title="Move down">&#9660;</span>
            </div>
            <div class="flex-cell pointer dtable-row" (click)="selectDeliverable(d)">{{d.description}}</div>
            <div class="flex-cell centered dtable-row"><img class="icon" src="delete_icon.svg" (click)="deleteDeliverable(d)"></div>
          </ng-container>
        </div>
      </div>

      <div *ngIf="selectedDeliverable" class="deliverable-details-panel">
        <h2>Deliverable Details</h2>
        <div class="deliverable-form">
          <div class="deliverable-field">
            <label>Description: </label>
            <input type="text" class="dark-input wide" [(ngModel)]="selectedDeliverable.description"
              (ngModelChange)="onDeliverableChange(selectedDeliverable.id, 'description', selectedDeliverable.description)">
          </div>

          <div class="deliverable-field">
            <label>Bullet Points:</label>
            <textarea class="dark-input deliverable-textarea" [(ngModel)]="selectedDeliverable.bulletPoints"
              (ngModelChange)="onDeliverableChange(selectedDeliverable.id, 'bulletPoints', selectedDeliverable.bulletPoints)">
            </textarea>
          </div>

          <div class="deliverable-field">
            <label>Caption:</label>
            <textarea class="dark-input deliverable-textarea" [(ngModel)]="selectedDeliverable.caption"
              (ngModelChange)="onDeliverableChange(selectedDeliverable.id, 'caption', selectedDeliverable.caption)">
            </textarea>
          </div>

          <div class="deliverable-field">
            <label>Post Instructions:</label>
            <textarea class="dark-input deliverable-textarea" [(ngModel)]="selectedDeliverable.postInstructions"
              (ngModelChange)="onDeliverableChange(selectedDeliverable.id, 'postInstructions', selectedDeliverable.postInstructions)">
            </textarea>
          </div>

          <div class="deliverable-field">
            <label>Ad Disclosure:</label>
            <textarea class="dark-input deliverable-textarea" [(ngModel)]="selectedDeliverable.adDisclosure"
              (ngModelChange)="onDeliverableChange(selectedDeliverable.id, 'adDisclosure', selectedDeliverable.adDisclosure)">
            </textarea>
          </div>

          <div class="deliverable-field">
            <label>Live Link:</label>
            <input type="text" class="dark-input wide" [(ngModel)]="selectedDeliverable.liveLink"
              (ngModelChange)="onDeliverableChange(selectedDeliverable.id, 'liveLink', selectedDeliverable.liveLink)">
          </div>

          <hr>

          <div class="deliverable-field">
            <label>Usage: <img class="add-icon" src="add_icon.svg" (click)="addUsage()"></label>
            <div *ngIf="!selectedDeliverable.usage || selectedDeliverable.usage.length === 0" class="no-files">
              Deliverable has no usage defined.
            </div>
            <div *ngIf="selectedDeliverable.usage && selectedDeliverable.usage.length > 0" class="usage-table">
              <div class="flex-cell">Type</div>
              <div class="flex-cell">Duration (Days)</div>
              <div class="flex-cell">Delete</div>
              <ng-container *ngFor="let usage of selectedDeliverable.usage; let i = index">
                <div class="flex-cell">
                  <select class="dark-input usage-type-select" [(ngModel)]="usage.type"
                    (ngModelChange)="onUsageChange(usage.id, 'type', usage.type)">
                    <option value="">Select usage type...</option>
                    <option value="Organic Usage">Organic Usage</option>
                    <option value="Paid Usage">Paid Usage</option>
                    <option value="Amplification">Amplification</option>
                    <option value="Editing Rights">Editing Rights</option>
                    <option value="Content Licensing">Content Licensing</option>
                    <option value="Retail Usage">Retail Usage</option>
                    <option value="Broadcast Usage">Broadcast Usage</option>
                  </select>
                </div>
                <div class="flex-cell">
                  <input type="number" class="dark-input usage-duration-input" [(ngModel)]="usage.durationInDays"
                    (ngModelChange)="onUsageChangeDebounced(usage.id, 'durationInDays', usage.durationInDays)"
                    placeholder="Days" min="0" required>
                </div>
                <div class="flex-cell centered">
                  <img class="icon" src="delete_icon.svg" (click)="removeUsageFromDeliverable(i)" alt="Delete Usage">
                </div>
              </ng-container>
            </div>
          </div>

          <hr>

          <div class="deliverable-field">
            <label>Files:</label>
            <div *ngIf="!selectedDeliverable.files || selectedDeliverable.files.length === 0" class="no-files">
              No files attached to this deliverable.
            </div>
            <div *ngIf="selectedDeliverable.files && selectedDeliverable.files.length > 0" class="files-table-small">
              <div class="file-header">Description</div>
              <div class="file-header">Brand Feedback</div>
              <div class="file-header">Approved</div>
              <div class="file-header">Delete</div>
              <ng-container *ngFor="let file of selectedDeliverable.files; let i = index">
                <div class="file-cell">{{file.description}}</div>
                <div class="file-cell">
                  <textarea rows="4" class="dark-input brand-feedback-textarea" [(ngModel)]="file.brandFeedback"
                    (ngModelChange)="onFileChange(file.fileId, 'brandFeedback', file.brandFeedback)"
                    placeholder="Enter brand feedback..."></textarea>
                </div>
                <div class="file-cell centered">
                  <input type="checkbox" [(ngModel)]="file.approved" (ngModelChange)="onFileChange(file.fileId, 'approved', file.approved)">
                </div>
                <div class="file-cell centered">
                  <img class="icon pointer" src="delete_icon.svg" (click)="removeFileFromDeliverable(i)" alt="Delete File">
                </div>
              </ng-container>
            </div>

            <div *ngIf="files && files.length > 0" class="add-file-section">
              <h4>Add File to Deliverable:</h4>
              <div class="add-file-form">
                <div class="form-row">
                  <label>Select File:</label>
                  <select class="dark-input" [(ngModel)]="selectedFileToAdd">
                    <option value="">Choose a file...</option>
                    <option *ngFor="let file of files" [value]="file.id">{{file.name}}</option>
                  </select>
                </div>
                <div class="form-row">
                  <label>Description:</label>
                  <input type="text" class="dark-input wide" [(ngModel)]="fileDescriptionToAdd"
                    placeholder="Enter description for this file...">
                </div>
                <div class="form-row">
                  <button class="add-file-button"
                    [disabled]="!selectedFileToAdd || !fileDescriptionToAdd || !fileDescriptionToAdd.trim()"
                    (click)="addFileToDeliverable()">
                    Add File
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="!files || files.length === 0" class="no-campaign-files">
              No files attached to this campaign.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tasks Tab -->
    <div *ngIf="activeTab === 'tasks'" class="tab-full-width">
      <div class="tasks-table-wrapper">
        <div class="deliverable-add-row">
          <img class="add-icon-lg" src="add_icon.svg" (click)="addTask()">
        </div>
        <div *ngIf="isLoadingTasks" class="no-items-msg">Loading tasks...</div>
        <div class="tasks-table" *ngIf="!isSmallScreen">
          <div class="flex-cell dtable-header task-shift-header">
            <div class="task-shift-controls">
              <input type="number" class="task-shift-input" [(ngModel)]="shiftDays" title="Days to shift (negative to go back)">
              <button class="task-shift-btn" (click)="shiftDueDates()" [disabled]="selectedTaskIds.size === 0">Shift</button>
            </div>
            <span>Select</span>
            <div class="centered">
              <input type="checkbox" [checked]="selectAllTasks" (change)="toggleSelectAllTasks($any($event.target).checked)">
            </div>
          </div>
          <div class="flex-cell dtable-header">Complete</div>
          <div class="flex-cell dtable-header centered" title="Creator Facing">CF</div>
          <div class="flex-cell dtable-header centered" title="Payment Related">$</div>
          <div class="flex-cell dtable-header header-left">Due Date</div>
          <div class="flex-cell dtable-header header-left">Description</div>
          <div class="flex-cell dtable-header">Delete</div>
          <div class="flex-cell dtable-header">ID</div>
          <ng-container *ngFor="let t of sortedTasks">
            <div class="flex-cell centered dtable-row" [class.overdue-row]="isTaskOverdue(t)">
              <input *ngIf="!t.complete" type="checkbox" [checked]="selectedTaskIds.has(t.id)" (change)="selectedTaskIds.has(t.id) ? selectedTaskIds.delete(t.id) : selectedTaskIds.add(t.id)">
            </div>
            <div class="flex-cell centered dtable-row" [class.overdue-row]="isTaskOverdue(t)">
              <div (click)="t.complete = !t.complete; onTaskChange(t, 'complete', t.complete);" role="checkbox">
                <ng-container *ngIf="t.complete; else notComplete">
                  <img class="icon" src="check_icon.svg">
                </ng-container>
                <ng-template #notComplete>
                  <img class="icon" src="uncheck_icon.svg">
                </ng-template>
              </div>
            </div>
            <div class="flex-cell centered dtable-row" [class.overdue-row]="isTaskOverdue(t)"><input type="checkbox" [(ngModel)]="t.creatorFacing" (ngModelChange)="onTaskChange(t, 'creatorFacing', t.creatorFacing)"></div>
            <div class="flex-cell centered dtable-row" [class.overdue-row]="isTaskOverdue(t)"><input type="checkbox" [(ngModel)]="t.paymentRelated" (ngModelChange)="onTaskChange(t, 'paymentRelated', t.paymentRelated)"></div>
            <div class="flex-cell dtable-row" [class.overdue-row]="isTaskOverdue(t)"><input class="date" type="date" [(ngModel)]="t.dueDate" (ngModelChange)="onTaskChange(t, 'dueDate', t.dueDate)"></div>
            <div class="flex-cell dtable-row" [class.overdue-row]="isTaskOverdue(t)">
              <input type="text" class="dark-input task-description-input" [(ngModel)]="t.description" (ngModelChange)="onTaskChange(t, 'description', t.description)">
            </div>
            <div class="flex-cell centered dtable-row" [class.overdue-row]="isTaskOverdue(t)"><img class="icon" src="delete_icon.svg" (click)="deleteTask(t)"></div>
            <div class="flex-cell dtable-row task-id-cell" [class.overdue-row]="isTaskOverdue(t)">{{t.id.substring(0, 8)}}</div>
          </ng-container>
        </div>

        <!-- Phones: one card per task instead of the 8-column grid -->
        <div class="task-cards" *ngIf="isSmallScreen">
          <div class="task-cards-toolbar">
            <label class="task-select-all">
              <input type="checkbox" [checked]="selectAllTasks" (change)="toggleSelectAllTasks($any($event.target).checked)">
              Select all
            </label>
            <div class="task-shift-controls">
              <span class="handle-label">Shift days</span>
              <input type="number" class="task-shift-input" [(ngModel)]="shiftDays" title="Days to shift (negative to go back)">
              <button class="task-shift-btn" (click)="shiftDueDates()" [disabled]="selectedTaskIds.size === 0">Shift</button>
            </div>
          </div>

          <div class="task-card" *ngFor="let t of sortedTasks" [class.overdue-card]="isTaskOverdue(t)" [class.complete-card]="t.complete">
            <div class="task-card-top">
              <div class="task-complete-toggle" (click)="t.complete = !t.complete; onTaskChange(t, 'complete', t.complete);" role="checkbox" [attr.aria-checked]="t.complete">
                <img class="icon" [src]="t.complete ? 'check_icon.svg' : 'uncheck_icon.svg'">
              </div>
              <input type="text" class="dark-input task-card-description" [(ngModel)]="t.description" (ngModelChange)="onTaskChange(t, 'description', t.description)">
              <img class="icon task-card-delete" src="delete_icon.svg" (click)="deleteTask(t)">
            </div>
            <div class="task-card-bottom">
              <input class="date" type="date" [(ngModel)]="t.dueDate" (ngModelChange)="onTaskChange(t, 'dueDate', t.dueDate)">
              <label title="Creator Facing"><input type="checkbox" [(ngModel)]="t.creatorFacing" (ngModelChange)="onTaskChange(t, 'creatorFacing', t.creatorFacing)"> CF</label>
              <label title="Payment Related"><input type="checkbox" [(ngModel)]="t.paymentRelated" (ngModelChange)="onTaskChange(t, 'paymentRelated', t.paymentRelated)"> $</label>
              <label *ngIf="!t.complete" title="Select for shifting"><input type="checkbox" [checked]="selectedTaskIds.has(t.id)" (change)="selectedTaskIds.has(t.id) ? selectedTaskIds.delete(t.id) : selectedTaskIds.add(t.id)"> Select</label>
              <span class="task-id-cell">{{t.id.substring(0, 8)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Invoices Tab -->
    <div *ngIf="activeTab === 'invoices'" class="tab-full-width">
      <div class="invoices-table-wrapper">
        <div class="deliverable-add-row">
          <button class="site-button add-invoice-btn" (click)="addInvoice()">Add New Invoice</button>
        </div>

        <div *ngIf="isLoadingInvoices" class="upload-loading">
          <div class="upload-spinner"></div>
          <p>Loading invoices...</p>
        </div>

        <ng-container *ngIf="!isLoadingInvoices">
          <div *ngIf="invoices.length === 0" class="no-items-msg">No Invoices Yet</div>
          <div *ngIf="invoices.length > 0" class="invoices-table" [class.admin]="isAdmin">
            <div class="flex-cell dtable-header">Number</div>
            <div class="flex-cell dtable-header right">Amount</div>
            <div class="flex-cell dtable-header right">Issue Date</div>
            <div class="flex-cell dtable-header right">Due Date</div>
            <div *ngIf="isAdmin" class="flex-cell dtable-header">Delete</div>
            <ng-container *ngFor="let i of invoices">
              <div class="flex-cell dtable-row"><a href="#" (click)="invoiceClick(i, $event)">{{i.invoiceNumber}}</a></div>
              <div class="flex-cell right dtable-row">{{ getTotalInvoiceAmount(i) | currency:'USD':'symbol':'1.2-2' }}</div>
              <div class="flex-cell dtable-row">{{i.issueDate}}</div>
              <div class="flex-cell dtable-row">{{i.dueDate}}</div>
              <div *ngIf="isAdmin" class="flex-cell centered dtable-row"><img class="icon" src="delete_icon.svg" (click)="deleteInvoice(i)"></div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div *ngIf="selectedInvoice" class="invoice-details-panel">
        <h2>Invoice {{selectedInvoice.invoiceNumber}}</h2>
        <div class="status-container payment-section status-fields-section">
          <div class="payment-section-header">Status Fields</div>
          <div class="status-row">
            <div class="status-label">Internal Status:</div>
            <div class="status-input"><input class="dark-input wide" type="text" [(ngModel)]="selectedInvoice.statusNote" (blur)="onInvoiceFieldChange('statusNote', selectedInvoice.statusNote)"></div>
          </div>
          <div class="status-row">
            <div class="status-label">Creator Facing Status:</div>
            <div class="status-input"><input class="dark-input wide" type="text" [(ngModel)]="selectedInvoice.creatorFacingStatus" (blur)="onInvoiceFieldChange('creatorFacingStatus', selectedInvoice.creatorFacingStatus)"></div>
          </div>
        </div>
        <div class="invoice-centered-wrap">
        <div class="invoice-details-container">
          <div class="invoice-details-left payment-section">
            <div class="payment-section-header">Invoice Fields</div>
            <div class="invoice-dates-row">
              <div class="invoice-dates-col">
                <div class="invoice-field">
                  <div>Issue Date</div>
                  <div><input class="date" type="date" [(ngModel)]="selectedInvoice.issueDate" (ngModelChange)="onInvoiceFieldChange('issueDate', $event, true)"></div>
                </div>
                <div class="invoice-field">
                  <div>Due Date</div>
                  <div><input class="date" type="date" [(ngModel)]="selectedInvoice.dueDate" (ngModelChange)="onInvoiceFieldChange('dueDate', $event, true)"></div>
                </div>
              </div>
              <div class="invoice-field">
                <div>Bill To</div>
                <div><textarea class="bill-to" [(ngModel)]="selectedInvoice.billTo" (blur)="onInvoiceFieldChange('billTo', selectedInvoice.billTo, true)"></textarea></div>
              </div>
              <div class="invoice-field">
                <div>Invoice Notes</div>
                <div><textarea class="bill-to" [(ngModel)]="selectedInvoice.invoiceNotes" (blur)="onInvoiceFieldChange('invoiceNotes', selectedInvoice.invoiceNotes, true)"></textarea></div>
              </div>
            </div>

            <div class="line-item-container">
              <div>Lines Items <img class="add-icon" src="add_icon.svg" (click)="addLineItem()"></div>
              <div *ngIf="selectedInvoice.lineItems.length === 0">No existing line items.</div>
              <div *ngIf="selectedInvoice.lineItems.length > 0" class="line-item-table">
                <div class="flex-cell">Description</div>
                <div class="flex-cell">Amount</div>
                <div class="flex-cell">Type</div>
                <div class="flex-cell">Delete</div>
                <ng-container *ngFor="let lineitem of selectedInvoice.lineItems; index as i">
                  <div class="flex-cell">
                    <input type="text" class="dark-input description-input" [(ngModel)]="lineitem.description" (blur)="onLineItemChange(i, 'description', lineitem.description)">
                  </div>
                  <div class="flex-cell right">
                    <input type="number" class="dark-input unit-price-input" [(ngModel)]="lineitem.unitPrice" (blur)="onLineItemChange(i, 'unitPrice', lineitem.unitPrice)">
                  </div>
                  <div class="flex-cell centered">
                    <select class="dark-input" [ngModel]="lineitem.lineItemType ?? null" (ngModelChange)="lineitem.lineItemType = $event; onLineItemChange(i, 'lineItemType', $event)">
                      <option [ngValue]="null" disabled hidden></option>
                      <option [ngValue]="'BasePayment'">Base Payment</option>
                      <option [ngValue]="'VtPaidExpense'">VT Paid Expense</option>
                      <option [ngValue]="'CreatorPaidExpense'">Creator Paid Expense</option>
                      <option [ngValue]="'CreatorPaidCommission'">Creator Paid Commission</option>
                    </select>
                  </div>
                  <div class="flex-cell centered">
                    <a href="#" (click)="deleteLineItem(i); $event.preventDefault();">
                      <img src="delete_icon.svg" alt="Delete Invoice" width="20" height="20">
                    </a>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="invoice-details-right">
            <div class="payment-section">
              <div class="payment-section-header">Record Incoming Payment</div>
              <div class="invoice-data-table">
                <div>Paid Date</div>
                <div><input class="date" type="date" [(ngModel)]="selectedInvoice.paidDate" (blur)="onInvoiceFieldChange('paidDate', selectedInvoice.paidDate)"></div>
                <div>In Reference</div>
                <div class="flex-cell"><input class="dark-input" type="text" [(ngModel)]="selectedInvoice.inRef" (blur)="onInvoiceFieldChange('inRef', selectedInvoice.inRef)"></div>
                <div>Actual Pay Amount</div>
                <div class="flex-cell"><input class="dark-input" type="text" [(ngModel)]="selectedInvoice.actualPayAmount" (blur)="onInvoiceFieldChange('actualPayAmount', selectedInvoice.actualPayAmount)"></div>
              </div>
            </div>

            <div class="payment-section">
              <div class="payment-section-header">Record Outgoing Payment</div>
              <div class="invoice-data-table">
                <div>Creator Paid Date</div>
                <div><input class="date" type="date" [(ngModel)]="selectedInvoice.creatorPaidDate" (blur)="onInvoiceFieldChange('creatorPaidDate', selectedInvoice.creatorPaidDate)"></div>
                <div>Out Reference</div>
                <div class="flex-cell"><input class="dark-input" type="text" [(ngModel)]="selectedInvoice.outRef" (blur)="onInvoiceFieldChange('outRef', selectedInvoice.outRef)"></div>
                <div>Creator Pay Amount</div>
                <div class="flex-cell"><input class="dark-input" type="text" [(ngModel)]="selectedInvoice.creatorPayAmount" (blur)="onInvoiceFieldChange('creatorPayAmount', selectedInvoice.creatorPayAmount)"></div>
              </div>
            </div>
          </div>
        </div>

        <hr class="invoice-divider">
        </div>

        <div class="invoice-preview">
          <button (click)="downloadCurrentInvoice()" class="btn" style="margin-bottom: 10px;">Download PDF</button>
          <div #pdfPreview style="width: 900px; height: 1200px; border: 1px solid #ccc;"></div>
        </div>
      </div>
    </div>

    <!-- Exclusivities Tab -->
    <div *ngIf="activeTab === 'exclusivities'" class="tab-full-width">
      <div class="exclusivities-table-wrapper">
        <div class="deliverable-add-row">
          <img class="add-icon-lg" src="add_icon.svg" (click)="addExclusivity()">
        </div>
        <div class="excl-no-excl-row">
          <span class="handle-label">No Exclusivity:</span>
          <input type="checkbox" [(ngModel)]="campaign.noExclusivity" (ngModelChange)="onFieldChange('noExclusivity', campaign.noExclusivity)">
        </div>
        <div *ngIf="isLoadingExclusivities" class="no-items-msg">Loading exclusivities...</div>
        <div *ngIf="!isLoadingExclusivities && (!campaign.exclusivities || campaign.exclusivities.length === 0)" class="no-items-msg">No Exclusivities Yet</div>
        <div *ngIf="campaign.exclusivities && campaign.exclusivities.length > 0" class="exclusivity-table">
          <div class="flex-cell dtable-header">Start Date</div>
          <div class="flex-cell dtable-header">End Date</div>
          <div class="flex-cell dtable-header">Scope</div>
          <div class="flex-cell dtable-header">Delete</div>
          <ng-container *ngFor="let e of campaign.exclusivities">
            <div class="flex-cell top dtable-row"><input class="date" type="date" [(ngModel)]="e.startDate" (ngModelChange)="onExclusivityChange(e.id, 'startDate', e.startDate)"></div>
            <div class="flex-cell top dtable-row"><input class="date" type="date" [(ngModel)]="e.endDate" (ngModelChange)="onExclusivityChange(e.id, 'endDate', e.endDate)"></div>
            <div class="flex-cell dtable-row scope-cell">
              <textarea class="scope-textarea" [(ngModel)]="e.scope" (ngModelChange)="onExclusivityChange(e.id, 'scope', e.scope)"></textarea>
            </div>
            <div class="flex-cell centered top dtable-row"><img class="icon" src="delete_icon.svg" (click)="deleteExclusivity(e)"></div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Files Tab -->
    <div *ngIf="activeTab === 'files'" class="tab-full-width">
      <input #fileInput type="file" style="display: none;" (change)="onFileSelected($event)">
      <div class="files-table-wrapper">
        <div class="deliverable-add-row">
          <img class="add-icon-lg" src="add_icon.svg" (click)="addFile()">
        </div>

        <div *ngIf="isUploadingFile" class="upload-loading">
          <div class="upload-spinner"></div>
          <p>Uploading file...</p>
        </div>

        <div *ngIf="!isUploadingFile && isLoadingFiles" class="upload-loading">
          <div class="upload-spinner"></div>
          <p>Loading files...</p>
        </div>

        <ng-container *ngIf="!isUploadingFile && !isLoadingFiles">
          <div *ngIf="files.length === 0" class="no-items-msg">No Files Yet</div>
          <div *ngIf="files.length > 0" class="files-table">
            <div class="flex-cell dtable-header">File Name</div>
            <div class="flex-cell dtable-header">Uploaded</div>
            <div class="flex-cell dtable-header">Delete</div>
            <ng-container *ngFor="let f of files">
              <div class="flex-cell pointer dtable-row" (click)="selectFile(f)">{{f.name}}</div>
              <div class="flex-cell dtable-row">{{f.createdTime | date:'yyyy-MM-dd'}}</div>
              <div class="flex-cell centered dtable-row"><img class="icon" src="delete_icon.svg" (click)="deleteGoogleDriveFile(f)"></div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div *ngIf="selectedFile" class="deliverable-details-panel">
        <div class="file-details">
          <div>File Name: {{selectedFile.name}}</div>
          <div>Uploaded Date: {{selectedFile.createdTime}}</div>
          <div>File ID: {{selectedFile.id}}</div>
          <div><a [href]="selectedFile.webViewLink" target="_blank">View File</a></div>
        </div>
        <app-edit-recommendations [file]="selectedFile" [campaignId]="campaign.id"></app-edit-recommendations>
      </div>
    </div>

    <!-- Live Videos Tab -->
    <div *ngIf="activeTab === 'liveVideos'" class="tab-full-width">
      <div class="live-videos">
        <div class="live-videos-share" *ngIf="!isLoadingVideos && campaignVideos.length > 0">
          <a class="live-videos-share-link" [href]="publicAnalyticsUrl" target="_blank" rel="noopener">
            Public Campaign Analytics Report
          </a>
          <img class="copy-icon" src="copy_icon.svg"
               [alt]="copiedShareUrl ? 'Copied' : 'Copy link'"
               [title]="copiedShareUrl ? 'Copied!' : 'Copy link'"
               (click)="copyPublicAnalyticsUrl()">
        </div>
        <div class="live-videos-add">
          <input class="dark-input wide" type="text" placeholder="Paste TikTok / Instagram / YouTube URL"
                 [(ngModel)]="newVideoUrl" (keydown.enter)="addCampaignVideo()" />
          <button class="site-button blue" (click)="addCampaignVideo()" [disabled]="isAddingVideo || !newVideoUrl">
            {{ isAddingVideo ? 'Adding…' : 'Add Video' }}
          </button>
        </div>
        <div *ngIf="addVideoError" class="live-videos-error">{{ addVideoError }}</div>

        <div *ngIf="isLoadingVideos" class="live-videos-loading">Loading videos…</div>

        <div *ngIf="!isLoadingVideos && campaignVideos.length === 0" class="live-videos-empty">
          No videos yet. Paste a URL above to get started.
        </div>

        <div class="live-video-card" *ngFor="let v of campaignVideos">
          <div class="live-video-thumb">
            <img *ngIf="v.thumbnailUrl" [src]="v.thumbnailUrl" alt="thumbnail" />
            <div *ngIf="!v.thumbnailUrl" class="live-video-thumb-placeholder">{{ v.platform }}</div>
          </div>
          <div class="live-video-body">
            <div class="live-video-row">
              <span class="live-video-platform">{{ v.platform }}</span>
              <a [href]="v.shareUrl || v.url" target="_blank" rel="noopener">Open</a>
            </div>
            <div *ngIf="v.analyticsAvailable" class="live-video-metrics">
              <span><strong>{{ v.views | number }}</strong> views</span>
              <span><strong>{{ v.likes | number }}</strong> likes</span>
              <span><strong>{{ v.comments | number }}</strong> comments</span>
              <span><strong>{{ v.shares | number }}</strong> shares</span>
            </div>
            <div *ngIf="!v.analyticsAvailable" class="live-video-warning">
              {{ v.lastError || 'No analytics available' }}
            </div>
            <div class="live-video-row live-video-footer">
              <span class="live-video-refresh-time">
                <ng-container *ngIf="v.lastRefresh">Refreshed {{ v.lastRefresh | date:'short' }}</ng-container>
              </span>
              <button class="link-button" (click)="refreshCampaignVideo(v)" [disabled]="refreshingVideoId === v.id">
                {{ refreshingVideoId === v.id ? 'Refreshing…' : 'Refresh' }}
              </button>
              <button class="link-button danger" (click)="deleteCampaignVideo(v)">Remove</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Read-only object viewer (campaign / invoice / task / deliverable / exclusivity) opened from the Changes tab -->
    <app-dialog [(visible)]="showObjectDialog">
      <div class="object-dialog">
        <div class="object-dialog-title">{{viewedType}}</div>
        <div *ngIf="isLoadingViewedObject" class="no-items-msg">Loading {{viewedType?.toLowerCase()}}...</div>
        <div *ngIf="viewedObjectError" class="no-items-msg">{{viewedObjectError}}</div>
        <div *ngIf="viewedTask" class="object-dialog-grid">
          <div class="object-dialog-label">ID</div><div>{{viewedTask.id}}</div>
          <div class="object-dialog-label">Description</div><div>{{viewedTask.description}}</div>
          <div class="object-dialog-label">Due Date</div><div>{{viewedTask.dueDate}}</div>
          <div class="object-dialog-label">Complete</div><div>{{viewedTask.complete ? 'Yes' : 'No'}}</div>
          <div class="object-dialog-label">Creator Facing</div><div>{{viewedTask.creatorFacing ? 'Yes' : 'No'}}</div>
          <div class="object-dialog-label">Payment Related</div><div>{{viewedTask.paymentRelated ? 'Yes' : 'No'}}</div>
        </div>
        <div *ngIf="viewedExclusivity" class="object-dialog-grid">
          <div class="object-dialog-label">ID</div><div>{{viewedExclusivity.id}}</div>
          <div class="object-dialog-label">Start Date</div><div>{{viewedExclusivity.startDate}}</div>
          <div class="object-dialog-label">End Date</div><div>{{viewedExclusivity.endDate}}</div>
          <div class="object-dialog-label">Scope</div><div class="object-dialog-text">{{viewedExclusivity.scope}}</div>
        </div>
        <div *ngIf="viewedInvoice" class="object-dialog-grid">
          <div class="object-dialog-label">ID</div><div>{{viewedInvoice.id}}</div>
          <div class="object-dialog-label">Invoice Number</div><div>{{viewedInvoice.invoiceNumber}}</div>
          <div class="object-dialog-label">Bill To</div><div class="object-dialog-text">{{viewedInvoice.billTo}}</div>
          <div class="object-dialog-label">Issue Date</div><div>{{viewedInvoice.issueDate}}</div>
          <div class="object-dialog-label">Due Date</div><div>{{viewedInvoice.dueDate}}</div>
          <div class="object-dialog-label">Paid Date</div><div>{{viewedInvoice.paidDate}}</div>
          <div class="object-dialog-label">Actual Pay Amount</div><div>{{viewedInvoice.actualPayAmount | currency:'USD':'symbol':'1.2-2'}}</div>
          <div class="object-dialog-label">Creator Paid Date</div><div>{{viewedInvoice.creatorPaidDate}}</div>
          <div class="object-dialog-label">Creator Pay Amount</div><div>{{viewedInvoice.creatorPayAmount | currency:'USD':'symbol':'1.2-2'}}</div>
          <div class="object-dialog-label">In Ref</div><div>{{viewedInvoice.inRef}}</div>
          <div class="object-dialog-label">Out Ref</div><div>{{viewedInvoice.outRef}}</div>
          <div class="object-dialog-label">Show Wire</div><div>{{viewedInvoice.showWire ? 'Yes' : 'No'}}</div>
          <div class="object-dialog-label">Status Note</div><div class="object-dialog-text">{{viewedInvoice.statusNote}}</div>
          <div class="object-dialog-label">Creator Facing Status</div><div>{{viewedInvoice.creatorFacingStatus}}</div>
          <div class="object-dialog-label">Invoice Notes</div><div class="object-dialog-text">{{viewedInvoice.invoiceNotes}}</div>
          <div class="object-dialog-label">Line Items</div>
          <div>
            <div *ngFor="let li of viewedInvoice.lineItems">{{li.description}} - {{li.unitPrice | currency:'USD':'symbol':'1.2-2'}}<span *ngIf="li.lineItemType"> ({{li.lineItemType}})</span></div>
            <span *ngIf="!viewedInvoice.lineItems?.length">None</span>
            <div *ngIf="viewedInvoice.lineItems?.length" class="object-dialog-total">Total: {{getTotalInvoiceAmount(viewedInvoice) | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
        </div>
        <div *ngIf="viewedCampaign" class="object-dialog-grid">
          <div class="object-dialog-label">ID</div><div>{{viewedCampaign.id}}</div>
          <div class="object-dialog-label">Name</div><div>{{viewedCampaign.name}}</div>
          <div class="object-dialog-label">Brand</div><div>{{viewedCampaign.brandName}}</div>
          <div class="object-dialog-label">Description</div><div class="object-dialog-text">{{viewedCampaign.description}}</div>
          <div class="object-dialog-label">Creative Overview</div><div class="object-dialog-text">{{viewedCampaign.creativeOverview}}</div>
          <div class="object-dialog-label">Usage</div><div class="object-dialog-text">{{viewedCampaign.usage}}</div>
          <div class="object-dialog-label">Rate</div><div>{{viewedCampaign.rate | currency:'USD':'symbol':'1.2-2'}}</div>
          <div class="object-dialog-label">Commission</div><div>{{viewedCampaign.commission}}</div>
          <div class="object-dialog-label">Payment Terms</div><div>{{viewedCampaign.paymentTerms}}</div>
          <div class="object-dialog-label">Payment Schedule</div><div class="object-dialog-text">{{viewedCampaign.paymentSchedule}}</div>
          <div class="object-dialog-label">Agent</div><div>{{resolveUserId(viewedCampaign.agentId)}}</div>
          <div class="object-dialog-label">Coordinator</div><div>{{resolveUserId(viewedCampaign.coordinatorId)}}</div>
          <div class="object-dialog-label">Created</div><div>{{viewedCampaign.createdDate}}</div>
          <div class="object-dialog-label">No Exclusivity</div><div>{{viewedCampaign.noExclusivity ? 'Yes' : 'No'}}</div>
          <div class="object-dialog-label">Complete</div><div>{{viewedCampaign.complete ? 'Yes' : 'No'}}</div>
          <div class="object-dialog-label">Deleted</div><div>{{viewedCampaign.deleted ? 'Yes' : 'No'}}</div>
          <div class="object-dialog-label">Reactivated</div><div>{{viewedCampaign.reactivated ? 'Yes' : 'No'}}</div>
        </div>
        <div *ngIf="viewedDeliverable" class="object-dialog-grid">
          <div class="object-dialog-label">ID</div><div>{{viewedDeliverable.id}}</div>
          <div class="object-dialog-label">Description</div><div>{{viewedDeliverable.description}}</div>
          <div class="object-dialog-label">Caption</div><div class="object-dialog-text">{{viewedDeliverable.caption}}</div>
          <div class="object-dialog-label">Post Instructions</div><div class="object-dialog-text">{{viewedDeliverable.postInstructions}}</div>
          <div class="object-dialog-label">Bullet Points</div><div class="object-dialog-text">{{viewedDeliverable.bulletPoints}}</div>
          <div class="object-dialog-label">Ad Disclosure</div><div>{{viewedDeliverable.adDisclosure}}</div>
          <div class="object-dialog-label">Live Link</div>
          <div><a *ngIf="viewedDeliverable.liveLink" [href]="viewedDeliverable.liveLink" target="_blank" rel="noopener">{{viewedDeliverable.liveLink}}</a></div>
          <div class="object-dialog-label">Usage</div>
          <div>
            <div *ngFor="let u of viewedDeliverable.usage">{{u.type}} - {{u.durationInDays}} days</div>
            <span *ngIf="!viewedDeliverable.usage?.length">None</span>
          </div>
          <div class="object-dialog-label">Files</div>
          <div>
            <div *ngFor="let f of viewedDeliverable.files">{{f.description || f.fileId}} - {{f.approved ? 'Approved' : 'Not approved'}}<span *ngIf="f.brandFeedback"> ({{f.brandFeedback}})</span></div>
            <span *ngIf="!viewedDeliverable.files?.length">None</span>
          </div>
        </div>
      </div>
    </app-dialog>

    <!-- Changes Tab -->
    <div *ngIf="activeTab === 'changes'" class="tab-full-width">
      <div class="changes-table-wrapper">
        <div *ngIf="isLoadingChanges" class="no-items-msg">Loading changes...</div>
        <div *ngIf="!isLoadingChanges && changesError" class="no-items-msg">
          Could not load changes. <a href="#" (click)="loadChanges(); $event.preventDefault()">Retry</a>
        </div>
        <div *ngIf="!isLoadingChanges && !changesError && changes.length === 0" class="no-items-msg">No Changes Yet</div>
        <div *ngIf="!isLoadingChanges && changes.length > 0" class="changes-table">
          <!-- Filter row: one cell per column -->
          <div class="changes-filter-cell">
            <input class="dark-input" type="text" placeholder="yyyy-MM-dd HH:mm:ss" [(ngModel)]="changeFilterDate">
          </div>
          <div class="changes-filter-cell">
            <select class="dark-input" [(ngModel)]="changeFilterUser">
              <option value="">All users</option>
              <option *ngFor="let u of changeUserOptions" [value]="u">{{u}}</option>
            </select>
          </div>
          <div class="changes-filter-cell">
            <select class="dark-input" [(ngModel)]="changeFilterType">
              <option value="">All types</option>
              <option *ngFor="let t of changeTypeOptions" [value]="t">{{t}}</option>
            </select>
          </div>
          <div class="changes-filter-cell">
            <select class="dark-input" [(ngModel)]="changeFilterField">
              <option value="">All fields</option>
              <option *ngFor="let f of changeFieldOptions" [value]="f">{{f}}</option>
            </select>
          </div>
          <div class="changes-filter-cell">
            <input class="dark-input" type="text" placeholder="Object ID" [(ngModel)]="changeFilterObjectId">
          </div>
          <div class="changes-filter-cell">
            <button class="link-button" *ngIf="hasChangeFilter" (click)="clearChangeFilters()">Clear filters</button>
          </div>
          <div class="changes-filter-cell"></div>
          <div class="flex-cell dtable-header header-left">Date</div>
          <div class="flex-cell dtable-header header-left">User</div>
          <div class="flex-cell dtable-header header-left">Type</div>
          <div class="flex-cell dtable-header header-left">Field</div>
          <div class="flex-cell dtable-header header-left">Object ID</div>
          <div class="flex-cell dtable-header header-left">Old Value</div>
          <div class="flex-cell dtable-header header-left">New Value</div>
          <ng-container *ngFor="let c of filteredChanges">
            <div class="flex-cell dtable-row">{{changeDateText(c)}}</div>
            <div class="flex-cell dtable-row">{{changeUserName(c)}}</div>
            <div class="flex-cell dtable-row">{{c.type}}</div>
            <div class="flex-cell dtable-row">{{changeFieldLabel(c)}}</div>
            <div class="flex-cell dtable-row" [class.pointer]="isViewableChange(c)" [class.change-object-link]="isViewableChange(c)"
                 [title]="isViewableChange(c) ? c.objectId + ' (click to view)' : c.objectId"
                 (click)="viewChangedObject(c)">{{c.objectId.substring(0, 8)}}</div>
            <div class="flex-cell dtable-row change-value">{{changeValueText(c, 'old')}}</div>
            <div class="flex-cell dtable-row change-value">{{changeValueText(c, 'new')}}</div>
          </ng-container>
        </div>
        <div *ngIf="!isLoadingChanges && changes.length > 0 && filteredChanges.length === 0" class="no-items-msg">No changes match the filters</div>
      </div>
    </div>

  </div>
</div>
